export default __webpack_public_path__ + "static/media/question_18.2943852d.png";